export const genderOption = (t) => {
    return [
        {value: 'M', label: t('register.male')},
        {value: 'F', label: t('register.female')}
    ];
}

export const getGender = (val, t) => {
    let gender = null;
    genderOption(t).forEach(value => {
        if (value.value === val)
            gender = value;
    })
    return gender;
}
